/* eslint-disable */
import axios from 'axios';

const API_URL = 'https://bewowebapirecipetool.azurewebsites.net/api/UserRole';

const login = async (username, password) => {
  // Check for super admin credentials
  if (username === 'BewoRoot' && password === 'o4bse') {
    const superAdminResponse = {
      user: {
        username: 'BewoRoot',
      },
      token: 'super_admin_fake_token',
    };
    // Store the super admin token
    localStorage.setItem('token', superAdminResponse.token); // Storing just the token
    return superAdminResponse;
  } else {
    // Proceed with normal login for other users
    try {
      const response = await axios.post(`${API_URL}/authenticate`, { username, password });
      if (response.data.token) {
        // Store just the token for the user session
        localStorage.setItem('token', response.data.token);
      }
      return response.data;
    } catch (error) {
      throw error; // Make sure to handle this error appropriately in your UI
    }
  }
};

export function getAuthToken() {
  // Retrieves the token stored under the 'token' key
  return localStorage.getItem('token');
}

export const authService = {
  login,
  // Placeholder for other authentication related methods (logout, refreshToken, etc.)
};
